import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import styles from './style/general.css';

const typeClasses = {
  error: 'bg-negative',
  success: 'bg-positive',
};

/**
 * Error and success message blocks to be used as feedback on forms and other
 * places requiring user input. Set the style with the optional `type` prop.
 */
export default function MessageBlock({
  children,
  fullWidth,
  isDisabled,
  type,
}) {
  const containerClasses = cx(styles.block, {
    [typeClasses[type]]: !isDisabled,
    'bg-smoke--xd': isDisabled,
    'width-100': fullWidth,
  });

  return <div className={containerClasses}>{children}</div>;
}

MessageBlock.propTypes = {
  children: PropTypes.node.isRequired,
  fullWidth: PropTypes.bool,
  isDisabled: PropTypes.bool,
  type: PropTypes.oneOf(Object.keys(typeClasses)).isRequired,
};

MessageBlock.defaultProps = {
  fullWidth: false,
  type: 'medium',
};



// WEBPACK FOOTER //
// ./packages/marvel-ui-message-block/MessageBlock/index.js